import styled, { css } from 'styled-components';
import { theme } from 'modules/tetrisTheme';
import { responsiveProperty } from 'modules/utils/responsiveProperty';
const labelInvalidStyles = css `
  color: ${theme.semantic.text.danger};
`;
/** @deprecated - Should be removed once the $labelSize prop is removed. */
const labelFontSize = {
    small: theme.fontSize.small,
    medium: theme.fontSize.medium,
    large: theme.fontSize.large,
};
export const StyledLabel = styled.label `
  display: inline-block;
  font: ${theme.fontRole.label};
  color: ${theme.semantic.foreground.tertiary};
  transition: color 0.1s ease-in-out;
  font-size: ${(props) => labelFontSize[props.$labelSize || 'small']};
  ${(props) => props.$fontSize && responsiveProperty('fontSize', props.$fontSize)};

  &:has(+ * :disabled) {
    color: ${theme.swatches.warm[500]};
  }

  &:has(+ * :focus-visible) {
    color: ${(props) => !props.$invalid && theme.semantic.foreground.primary};
  }

  ${(props) => props.$invalid && labelInvalidStyles};
`;
